import { SeriesAreaOptions, SeriesOptions } from 'highcharts/highstock';
import { DeviceConsumptionResult } from 'types';
import {
    convertConsumptionTime,
    getDataFromPrediction,
    sortSeries,
} from '../general';

export const addConSeries = (
    series: SeriesOptions[],
    lastReading: number,
    consumption: DeviceConsumptionResult
) => {
    let lastConsumption = 0;
    const conData = [];
    for (const readingId in consumption) {
        const reading = consumption[readingId];
        const date = convertConsumptionTime(readingId);
        let processedReading = reading.consumption;
        if (typeof processedReading === 'string')
            processedReading = parseFloat(processedReading);
        if (!!processedReading || processedReading === 0) {
            conData.push([date, processedReading]);
            lastConsumption = date;
        }
    }
    for (const readingId in consumption) {
        const reading = consumption[readingId];
        if (!!reading.predictions) {
            for (const date in reading.predictions) {
                const prediction = reading.predictions[date];
                const processedPrediction = getDataFromPrediction(
                    prediction,
                    lastConsumption,
                    lastReading
                );
                let consumptionNumber = processedPrediction.consumption;
                if (typeof consumptionNumber === 'string')
                    consumptionNumber = parseFloat(consumptionNumber);
                if (!!consumptionNumber || consumptionNumber === 0) {
                    conData.push([processedPrediction.date, consumptionNumber]);
                }
            }
        }
    }
    const conSeries: SeriesAreaOptions = {
        id: 'consumption',
        color: '#33C6DD',
        zoneAxis: 'x',
        zones: [
            {
                value: Number(new Date()),
                color: '#33C6DD',
            },
            {
                color: '#b7ebf3',
                dashStyle: 'Dash',
            },
        ],
        yAxis: 2,
        type: 'area',
        name: 'consumption',
        dataGrouping: { enabled: false },
        data: sortSeries(conData),
        tooltip: {
            valueSuffix: ' Gal',
            valueDecimals: 1,
            xDateFormat: '%b %e %l:%M %p',
        },
    };
    series.push(conSeries);
};
